import {Routes} from '@angular/router';
import {AppointmentResolver} from "./feature/resolvers/appointment.resolver";
import {ProcessedComponent} from "./feature/pages/processed/processed.component";
import {MaintenanceGuard} from "./core/services/maintenance.guard";
import {ProposalComponent} from "./feature/pages/proposal/proposal.component";
import {
  DeclinedTimeslotLookupComponent
} from "./feature/pages/declined-timeslot-lookup/declined-timeslot-lookup.component";
import {TimeSlotResolverGuard} from "./feature/resolvers/time-slot.resolver-guard";
import {AppointmentResolverGuard} from "./feature/resolvers/appointment.resolver-guard";
import {
  DeclinedNoTimeslotLookupComponent
} from "./feature/pages/declined-no-timeslot-lookup/declined-no-timeslot-lookup.component";
import {PageNotFoundComponent} from "./shared/pages/page-not-found/page-not-found.component";
import {MaintenanceComponent} from "./shared/pages/maintenance/maintenance.component";
import {AppointmentNotFoundComponent} from "./feature/pages/appoinment-not-found/appointment-not-found.component";
import {MessageReceivedComponent} from "./feature/pages/message-received/message-received.component";
import {AcceptedComponent} from "./feature/pages/accepted/accepted.component";
import {ErrorComponent} from "./shared/pages/error/error.component";
import {EmbedModeResolver} from "./feature/resolvers/embed-mode.resolver";
import {TestRunResolver} from "./feature/resolvers/test-run.resolver";
import {
  DeclinedTimeslotLookupNoResultsComponent
} from "./feature/pages/declined-timeslot-lookup-no-results/declined-timeslot-lookup-no-results.component";
import {SettingsResolver} from "./feature/resolvers/settings.resolver";

export const routes: Routes = [
  {
    path: '',
    canActivate: [MaintenanceGuard],
    resolve: {
      embedMode: EmbedModeResolver,
      testRun: TestRunResolver,
    },
    children: [
      {
        path: ':factoryId/:language/:id',
        resolve: {appointment: AppointmentResolverGuard, settings: SettingsResolver},
        children: [
          {path: '', redirectTo: 'proposal', pathMatch: 'full'},
          {path: 'proposal', component: ProposalComponent},
          {
            path: 'proposal/accepted',
            component: AcceptedComponent,
          },
          {
            path: 'proposal/alternative-timeslot-accepted',
            component: AcceptedComponent,
            resolve: {
              appointment: AppointmentResolver // make sure to resolve the appointment again
            }
          },
          {
            path: 'proposal/declined-timeslot-lookup',
            resolve: {timeSlots: TimeSlotResolverGuard},
            component: DeclinedTimeslotLookupComponent,
          },
          {path: 'proposal/declined-timeslot-lookup-no-results', component: DeclinedTimeslotLookupNoResultsComponent},
          {path: 'proposal/declined-no-timeslot-lookup', component: DeclinedNoTimeslotLookupComponent},
          {path: 'message-received', component: MessageReceivedComponent},
          {path: 'proposal/failed', component: ErrorComponent},
        ]
      },
      {
        path: 'processed/:factoryId/:language/:id',
        component: ProcessedComponent,
        resolve: {
          appointment: AppointmentResolver, settings: SettingsResolver
        }
      },
      {
        path: 'not-found/:factoryId/:language/:id',
        component: AppointmentNotFoundComponent
      },
    ]
  },
  {
    path: 'error',
    component: ErrorComponent
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: '**',
    component: PageNotFoundComponent
  }
];
